import { useEffect, useState, useCallback, FormEvent } from 'react';
import { useDispatch } from 'react-redux';
import { useLoginMutation } from '@api/authApi';
import { setPublicAuthToken, findPublicAuthToken } from '@features/authentication/storageFunctions';
import { LoginMode } from '@layouts/login-app/LoginMode';
import { AppModeEnum } from '@project-types/enums';
import { setAppMode } from '@store/global/slice';



const useLoginApp = () => {

	const [ loginMode, setLoginMode ] = useState(LoginMode.checkToken);
	const [ loginAttempts, setLoginAttempts ] = useState(0);

	const dispatch = useDispatch();
	const changeAppMode = (mode: AppModeEnum) => dispatch(setAppMode(mode));
	const [ runLogin, { isLoading } ] = useLoginMutation();


	useEffect(() => {
		let token = findPublicAuthToken();
		if (!token) {
			setLoginMode(LoginMode.loginRequired);
		}
	}, []);


	useEffect(() => {
		if (loginAttempts > 5) {
			changeAppMode(AppModeEnum.authFailed);
		}
	}, [ loginAttempts ]);

	
	const handleLogin = useCallback(async (username: string, password: string) => {
		try {
			let response = await runLogin({ username, password });

			if ('data' in response && response.data) {
				setPublicAuthToken(response.data);
				return;
			}

			if ('error' in response && 'status' in response.error && response.error.status === 401) {
				setLoginAttempts(loginAttempts + 1)
				setLoginMode(LoginMode.loginFailed);
				return;
			}

			changeAppMode(AppModeEnum.authFailed);
		}
		catch (error) {
			changeAppMode(AppModeEnum.authFailed);
		}
	}, [ loginAttempts ]);


	const handleSubmit = useCallback((event: FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		let data = Object.fromEntries(new FormData(event.currentTarget));
		let username = data['username'] as string;
		let password = data['password'] as string;

		if (username && password) {
			handleLogin(username, password);
		}
	},[ handleLogin ]);


	const validateEmail = useCallback((value: string): string | true => {
		if (!value || value.length === 0) return 'Povinné pole';
		if (!/^\S+@\S+\.\w+$/.test(value)) return 'Nesprávný tvar emailu';
		return true;
	},[]);


	return [ loginMode, isLoading, handleSubmit, validateEmail ] as const;
}

export default useLoginApp;